import { render, staticRenderFns } from "./AddAffiliationUserForm.vue?vue&type=template&id=2c65046e&lang=pug&"
import script from "./AddAffiliationUserForm.vue?vue&type=script&lang=ts&"
export * from "./AddAffiliationUserForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports